








































import mixins from 'vue-typed-mixins'
import DiaryMixin from '../../DiaryMixin'

import Activity from './Activity.vue'

export default mixins(DiaryMixin).extend({
  components: { Activity },
})
